import { useQuery } from 'react-query'

import { useLogger } from '@vp/ubik-context'

import { STALE_TIME_INFINITY } from './constants'
import { getSizeChart } from '../../clients/SizeChartClient'
import { useTenant } from '../../components/root/contexts/TenantContext'

export default function useSizeChart(locale: string, productKey: string) {
  const logger = useLogger()
  const { tenant } = useTenant()
  return useQuery(['sizeChart', tenant, locale, productKey], async () => await getSizeChart(tenant, locale, productKey, logger), {
    enabled: !!locale && !!productKey,
    staleTime: STALE_TIME_INFINITY,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })
}
